import dynamic from 'next/dynamic';
import { Spinner } from 'components/Spinner';

const DynamicLodgingForm = dynamic(() => import('./Form'), { loading: () => <Spinner /> });

export default DynamicLodgingForm;
